import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getSubGallery } from "../Service/Api";
import { Link } from "react-router-dom";
import HeaderMUN from "../Component/HeaderMUN";
import FooterMun from "../Component/FooterMun";
import Breadcrumb from "../Component/Breadcrumb";
import LazyLoad from "react-lazyload";

const MunSubGallery = () => {
  const navigate = useNavigate();

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const location = useLocation();
  const id = new URLSearchParams(location.search).get("id");
  const [data, setData] = useState("");
  const [index, setIndex] = React.useState(-1);

  useEffect(() => {
    const getData = async () => {
      try {
        const subgalleryData = await getSubGallery(id);
        setData(subgalleryData);
      } catch (error) {
        console.log(error);
      }
    };
    getData();
  }, [id]);

  return (
    <>
      <HeaderMUN />
      <Breadcrumb title={data.title} tabName={data.title} />
      <div className="innerPage">
        <div className="container">
          <div className="row tabs-dynamic">
            <div className="col-xxl-3 col-xl-3 col-lg-4 col-12">
              <div className="shrink">
                <Link onClick={handleBackButtonClick}>
                  <i className="bi bi-arrow-left"></i> Go Back
                </Link>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-4 col-12">
              <div><b>Event Date:</b> {data?.date ? new Date(data.date).toLocaleDateString("en-GB") : ""}</div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-4 col-12">
              <div className="month-selection">
                <div><b>Updated On:</b> {data?.date ? new Date(data.date).toLocaleDateString("en-GB") : ""}</div>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-4 col-12">
              <div className="month-selection">
                <div><b>Total Photos:</b> {data?.attachments?.length}</div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="fulwidth">
                <div className="discription">
                  <p>{data.description}</p>
                </div>
              </div>
              <div className="sub_gallery row">
                {data && data.attachments && data.attachments.length > 0 &&
                  data.attachments.map((img, imgIndex) => (
                    <div className="col-lg-3 col-md-6 col-sm-12" key={imgIndex}>
                      <a
                        data-magnify="gallery"
                        href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${img}`}
                        onClick={() => setIndex(imgIndex)}
                      >
                        <LazyLoad>
                          <img
                            src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${img}`}
                            className="img-fluid"
                            alt={`Image ${imgIndex}`}
                          />
                        </LazyLoad>
                      </a>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterMun />
    </>
  );
};

export default MunSubGallery;
